/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Injectable} from '@angular/core';
import {AbstractResourceService, JsonApiListResourceMetadataBase, JsonApiResource, SpecificationQueryParamsEventModel} from '@irian-ro/abstract-resource';
import {EmailDetailVO, EmailListVO} from '@well/delivery-libs/email-management/domain';
import {EnvironmentService} from "@irian-ro/util-environment";
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EmailResourceService extends AbstractResourceService<EmailListVO, EmailListVO, JsonApiListResourceMetadataBase, JsonApiListResourceMetadataBase> {

  private emailApiUrl: string;

  constructor(httpClient: HttpClient, environmentService: EnvironmentService) {
    super(
      httpClient,
      environmentService.getEnvironmentProperty('emailUrl'),
      EmailListVO,
      EmailListVO
    );
    this.emailApiUrl = environmentService.getEnvironmentProperty('emailUrl');
  }

  getOne(uuid: string): Observable<EmailDetailVO> {
    return this.httpClient.get<EmailDetailVO>(`${this.emailApiUrl}/${uuid}`);
  }

  override findAll(query?: SpecificationQueryParamsEventModel): Observable<JsonApiResource<EmailListVO[], JsonApiListResourceMetadataBase>> {
    const employeeUuidFilter = query?.filters?.['employeeUuid'];
    if (!employeeUuidFilter || typeof employeeUuidFilter.value !== 'boolean') {
      return super.findAll(query);
    }
    const { employeeUuid: _, ...restFilters } = query!.filters!;
    return super.findAll({ ...query, filters: restFilters }, [{ assignedToUser: String(employeeUuidFilter.value) }]);
  }

  ignoreEmail(uuid: string) {
    return this.httpClient.post(`${this.emailApiUrl}/${uuid}/ignore`, null);
  }

  unignoreEmail(uuid: string) {
    return this.httpClient.post(`${this.emailApiUrl}/${uuid}/unignore`, null);
  }

  unlockEmail(uuid: string) {
    return this.httpClient.post(`${this.emailApiUrl}/${uuid}/unlock`, null);
  }

  assignEmployee(uuid: string, employeeUuid: string) {
    return this.httpClient.put(`${this.emailApiUrl}/${uuid}/assignment/${employeeUuid}`, null);
  }

  removeEmployee(uuid: string) {
    return this.httpClient.delete(`${this.emailApiUrl}/${uuid}/unassign`);
  }
}
